import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchAuditLogs } from '../services/securityLogsService';
import { AuditAction, SecurityLogsState } from '../types/securityLogs.types';

const initialState: SecurityLogsState = {
    logs: [],
    total: 0,
    page: 1,
    pages: 1,
    loading: false,
    error: null,
    actionFilter: '',
};

export const fetchSecurityLogsThunk = createAsyncThunk(
    'securityLogs/fetch',
    async (
        { page, action }: { page: number; action: AuditAction | '' },
        { rejectWithValue }
    ) => {
        try {
            return await fetchAuditLogs(page, 50, action);
        } catch (err: any) {
            return rejectWithValue(
                err?.response?.data?.message ?? 'Failed to load audit logs'
            );
        }
    }
);

const securityLogsSlice = createSlice({
    name: 'securityLogs',
    initialState,
    reducers: {
        setActionFilter(state, action: PayloadAction<AuditAction | ''>) {
            state.actionFilter = action.payload;
            state.page = 1;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSecurityLogsThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSecurityLogsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.logs = action.payload.logs;
                state.total = action.payload.total;
                state.page = action.payload.page;
                state.pages = action.payload.pages;
            })
            .addCase(fetchSecurityLogsThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export const { setActionFilter } = securityLogsSlice.actions;
export default securityLogsSlice.reducer;
